/**
 * Proyecto: MOGOTAX-SERVER
 * Autor: Megatrack GPS SAS
 * Fecha de creación: 11 de noviembre 2024
 * Licencia: Propiedad Privada
 *
 * Este código es propiedad exclusiva de Megatrack GPS SAS & Mogotax SAS y no puede ser distribuido, copiado, modificado, publicado, sublicenciado ni comercializado sin el consentimiento expreso y por escrito de ambas empresa.
 *
 * Copyright (c) 2025 Megatrack GPS SAS. Todos los derechos reservados.
 */
import React, {
  createContext,
  useState,
  useEffect,
  useContext,
  useMemo,
} from "react";
import PropTypes from "prop-types";

// Crear el contexto
const CookieConsentContext = createContext();

// Proveedor del contexto
export const CookieConsentProvider = ({ children }) => {
  const [cookiesAccepted, setCookiesAccepted] = useState(null);

  // Cargar el estado desde localStorage
  useEffect(() => {
    const storedConsent = localStorage.getItem("cookiesAccepted");
    if (storedConsent !== null) {
      setCookiesAccepted(JSON.parse(storedConsent));
    }
  }, []);

  // Guardar la preferencia del usuario en localStorage
  useEffect(() => {
    if (cookiesAccepted !== null) {
      localStorage.setItem("cookiesAccepted", JSON.stringify(cookiesAccepted));
    }
  }, [cookiesAccepted]);

  // Memoizar el valor del contexto
  const contextValue = useMemo(
    () => ({ cookiesAccepted, setCookiesAccepted }),
    [cookiesAccepted]
  );

  return (
    <CookieConsentContext.Provider value={contextValue}>
      {children}
    </CookieConsentContext.Provider>
  );
};

// Validar las props del proveedor
CookieConsentProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// Hook para usar el contexto
export const useCookieConsent = () => useContext(CookieConsentContext);
